<template>
  <div class="report_data_details">
    <div class="one">
      <div class="business-info-view">
        <el-form
          :model="queryInfo"
          class="product_form"
          label-width="100px"
          :rules="rules"
          ref="ruleForm"
        >
          <p class="info-title">基础信息</p>

          <div class="business-info-block">
            <el-form-item label="报告名称：" label-width="190px">
              <el-input
                style="width: 867px;"
                v-model="queryInfo.reportName"
              ></el-input>
            </el-form-item>

            <el-form-item label="研报类型：" label-width="190px">
              <el-radio-group v-model="queryInfo.type">
                <el-radio label="单份报告">单份报告</el-radio>
                <el-radio label="报告合集">报告合集</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="研报类别："
              prop="reportType"
              label-width="190px"
            >
              <SelectTreeRadio
                apiName="getDicRadioButton"
                :params="{ code: '009' }"
                resultType="values"
                vFeild="codeId"
                lFeild="codeName"
                storageKey="reportTypeList"
                :isCheckBoxButton="false"
                v-model="queryInfo.reportType"
              ></SelectTreeRadio>
            </el-form-item>

            <el-form-item label="发布时间：" label-width="190px">
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                v-model="queryInfo.reportTime"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="一句话介绍：" label-width="190px">
              <el-input
                style="width: 867px;"
                v-model="queryInfo.reportBrief"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="报告图片："
              prop="pdfImage"
              label-width="190px"
            >
              <MyImageUpload
                :upLoadImgList.sync="queryInfo.pdfImageList"
                :limitCount="1"
                @upLoadImgList="e => onChangeUpLoadImgList('pdfImageList', e)"
              />
            </el-form-item>

            <el-form-item
              label="封面图："
              prop="coverImage"
              label-width="190px"
            >
              <MyImageUpload
                :upLoadImgList.sync="queryInfo.coverImageList"
                :limitCount="1"
                @upLoadImgList="e => onChangeUpLoadImgList('coverImageList', e)"
              />
            </el-form-item>

            <el-form-item
              label="合集链接："
              label-width="190px"
              prop="titleLink"
            >
              <el-link
                :href="queryInfo.reportCollection"
                target="_blank"
                :underline="false"
                >{{ queryInfo.reportCollection }}</el-link
              >

              <span class="edit-link-btn">
                <i
                  class="jr-iconjr-icon-edit1"
                  style="margin-left: 24px;"
                  @click="isLinkShow = true"
                ></i>
              </span>

              <div class="input_button" v-if="isLinkShow">
                <el-input
                  v-model="queryInfo.reportCollection"
                  style="width: 470px"
                />
                <el-button
                  type="primary"
                  style="height: 40px; margin-left: 24px"
                  @click="isLinkShow = false"
                  >保存</el-button
                >
              </div>
            </el-form-item>

            <el-form-item label="合集提取码：" label-width="190px">
              <el-input
                style="width: 867px;"
                v-model="queryInfo.fetchCode"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="研报链接："
              label-width="190px"
              prop="reportKey"
            >
              <el-link
                :href="queryInfo.reportKey"
                target="_blank"
                :underline="false"
                >{{ queryInfo.reportKey }}</el-link
              >

              <span class="edit-link-btn">
                <i
                  class="jr-iconjr-icon-edit1"
                  style="margin-left: 24px;"
                  @click="isRLinkShow = true"
                ></i>
              </span>

              <div class="input_button" v-if="isRLinkShow">
                <el-input v-model="queryInfo.reportKey" style="width: 470px" />
                <el-button
                  type="primary"
                  style="height: 40px; margin-left: 24px"
                  @click="isRLinkShow = false"
                  >保存</el-button
                >
              </div>
            </el-form-item>

            <el-form-item
              label="研报页数："
              label-width="190px"
              prop="reportPages"
            >
              <el-input
                style="width: 867px;"
                v-model="queryInfo.reportPages"
              ></el-input>
            </el-form-item>

            <div class="attr-info">
              <el-form-item label="研报附件：">
                <div class="operate-group">
                  <UploadFile
                    :buttonText="'上传附件'"
                    @success="uploadFactoryDoc"
                  />

                  <div class="delete-box">
                    <el-button
                      plain
                      size="small"
                      icon="el-icon-delete"
                      @click="handleDeletes"
                      >批量删除</el-button
                    >
                  </div>
                </div>
              </el-form-item>

              <div class="attr-table-box">
                <el-table
                  :data="reportFileList"
                  style="width: 870px"
                  @selection-change="reportsFilesChange"
                >
                  <el-table-column type="selection" width="105">
                  </el-table-column>

                  <el-table-column
                    label="附件名称"
                    prop="reportFileName"
                    width="500"
                  ></el-table-column>

                  <el-table-column label="操作" align="center">
                    <template slot-scope="{ row }">
                      <button-table
                        content="下载"
                        icon="jr-iconjr-icon-download"
                        @buttonClick="downloadFactoryDoc(row)"
                      />
                      <button-table
                        content="查看"
                        icon="jr-iconjr-icon-eye"
                        @buttonClick="handleView(row)"
                      />
                      <button-table
                        content="编辑"
                        icon="jr-iconjr-icon-edit"
                        @buttonClick="handleEdit(row)"
                      />
                      <button-table
                        content="删除"
                        icon="jr-iconjr-icon-delect"
                        :iconClolor="'#f56c6c'"
                        @buttonClick="handleDelete(row)"
                      />
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <el-form-item label="研报简介：" label-width="190px">
              <Editorbar v-model="queryInfo.reportIntro" :isClear="isClear" />
            </el-form-item>
          </div>

          <div class="business-info-block">
            <el-form-item label="赋能行业：" label-width="190px">
              <SelectTreeRadio
                :isTree="true"
                apiName="getIndustryList"
                :params="{
                  groupLabelType: '赋能行业标签组',
                  level: 4
                }"
                resultType="values"
                storageKey="industryCategoryList"
                v-model="queryInfo.reportLabelList"
                :isRadioFirstLevel="false"
                :isCheckBoxButton="false"
              ></SelectTreeRadio>
            </el-form-item>
          </div>

          <p class="info-title">爬虫信息</p>

          <div class="business-info-block">
            <el-form-item label="爬虫编号：" label-width="190px">
              <span>{{ queryInfo.crawlId }}</span>
            </el-form-item>

            <el-form-item label="爬虫名称：" label-width="190px">
              <el-input
                style="width: 867px;"
                v-model="queryInfo.crawlName"
              ></el-input>
            </el-form-item>

            <el-form-item label="爬取网站：" label-width="190px">
              <el-input
                style="width: 867px;"
                v-model="queryInfo.crawlWebsite"
              ></el-input>
            </el-form-item>

            <el-form-item label="爬取时间：" label-width="190px">
              <el-input
                style="width: 867px;"
                v-model="queryInfo.crawlTime"
              ></el-input>
            </el-form-item>
          </div>

          <!-- <el-form-item label="网盘链接:" prop="networkStorageLink">
            <el-input
              v-model="queryInfo.networkStorageLink"
              placeholder="请输入"
              style="width: 50%"
            />
          </el-form-item> -->

          <!-- <el-form-item label="提取码:" prop="fetchCode">
            <el-input
              v-model="queryInfo.fetchCode"
              placeholder="请输入"
              style="width: 50%"
            />
          </el-form-item> -->

          <!-- <el-form-item label="报告页数:" prop="reportPages">
            <el-input
              v-model="queryInfo.reportPages"
              placeholder="请输入"
              style="width: 50%"
            />
          </el-form-item> -->

          <!-- <div
            v-show="typeTwo"
            class="collection"
            v-for="(item, index) in queryInfo.reportCollectionResults"
            :key="index + 'res'"
            style="width: 100%"
          >
            <el-form-item label="报告合集:" prop="reportCollectionResults">
              <div style="display: flex; width: 100%">
                <div
                  style="
                    width: 50%;
                    border: 0.5px solid #dbdbdb;
                    padding: 10px 10px 10px 0;
                    border-radius: 5px;
                    box-sizing: border-box; ;
                  "
                >
                  <el-form-item
                    label="附件名称:"
                    prop="fileNameCollect"
                    style="margin-bottom: 10px"
                  >
                    <el-input
                      v-model="item.fileNameCollect"
                      placeholder="请输入"
                      style="width: 100%"
                    />
                  </el-form-item>
                  <el-form-item label="发布日期:" prop="releaseTime">
                    <el-input
                      v-model="item.releaseTime"
                      placeholder="请输入"
                      style="width: 100%"
                    />
                  </el-form-item>
                </div>
                <span style="color: #4e93fb" @click="addReport(item)">
                  <i
                    class="el-icon-circle-plus-outline"
                    style="font-size: 31px; cursor: pointer; margin-left: 10px"
                  ></i>
                </span>
                <span v-if="index > 0" @click="delReport(index)">
                  <i
                    class="el-icon-remove-outline"
                    style="
                      color: #ff7575;
                      font-size: 31px;
                      cursor: pointer;
                      margin-left: 10px;
                    "
                  ></i>
                </span>
              </div>
            </el-form-item>
          </div> -->

          <!-- <el-form-item label="发布日期:" prop="reportTime">
            <el-input
              v-model="queryInfo.reportTime"
              placeholder="请按照1999-01-01格式填写"
              style="width: 50%"
            />
          </el-form-item> -->

          <!-- <el-form-item label="发布机构:" prop="reportManager">
            <el-input
              v-model="queryInfo.reportManager"
              placeholder="请输入"
              style="width: 50%"
            />
          </el-form-item> -->

          <!-- <el-form-item label="报告附件:" prop="fileName" class="fileName">
            <el-input
              v-model="queryInfo.fileName"
              readonly
              style="width: 50%"
            />
            <upload-report-file
              @upFileKey="fileKey"
              @fileSucee="successUpload"
            />
          </el-form-item> -->

          <!-- <el-form-item label="报告简介:" prop="reportIntro">
            <Editorbar
              v-model="queryInfo.reportIntro"
              :isClear="isClear"
              style="width: 50%"
            />
          </el-form-item> -->

          <!-- <el-form-item label="行业类别:" prop="reportTags">
            <dic-port-details
              :code.sync="queryInfo.reportTags"
              tag="行业"
              @updateCode="updateCode"
            />
          </el-form-item>
          <el-form-item label="领域类别:" prop="fieldId">
            <dic-port-details
              :code.sync="queryInfo.fieldId"
              tag="领域"
              @updateCode="updateCode"
            />
          </el-form-item>
          <el-form-item label="领域标签:" v-if="ReportDataType">
            <el-input
              v-model="queryInfo.wisdomTag"
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 8 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="行业标签:" v-if="ReportDataType">
            <el-input
              v-model="queryInfo.IndustryTag"
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 8 }"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="关键词:"
            v-if="ReportDataType"
            label-width="100px"
          >
            <el-input
              v-model="queryInfo.antistop"
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 8 }"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>

      <!-- <div class="info_user" v-if="this.reportDataType">
        <div class="ess_people_list">创建人：{{ queryInfo.createName }}</div>
        <div class="ess_people_list">修改人：{{ queryInfo.updateName }}</div>
        <div class="ess_people_list">更新时间：{{ queryInfo.updateTime }}</div>
        <div class="ess_people_list">收录时间：{{ queryInfo.createTime }}</div>
      </div> -->
    </div>
    <!-- <div class="bottom">
      <el-button type="primary" @click="saveItem">保存</el-button>
      <el-button @click="cancelClick">取消</el-button>
    </div> -->

    <FileUploadPopup
      ref="fileUploadPopup"
      :show="popupShow"
      @close="popupShow = false"
      @uploadSuccess="handleUploadSuccess"
    />
  </div>
</template>

<script>
import DicPortDetails from "../com/dicPortDetails.vue";
import DicPortReout from "../com/dicPortReout.vue";
import UploadReportFile from "../com/uploadReportFile.vue";
import UpLoadImage from "../UpLoadImage";
import myUploadReportFile from "../com/myUploadReportFile.vue";
import Editorbar from "@/components/Editorbar";
//  报告基本信息详情
import { getReportDataDetails } from "@/api/report";
import {
  addNewPortData,
  getSingleReort,
  updatePortData
} from "../../../api/report";
import Vue from "vue";

// components
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import MyImageUpload from "@/components/MyImageUpload/index.vue";
import UploadFile from "@/components/UploadFile.vue";
import ButtonTable from "@/components/ButtonTable.vue";
import FileUploadPopup from "@/components/FileUploadPopup/index.vue";
// api
import {
  getReportMetaInfo,
  deleteReportFile,
  getReportFile,
  insertReportFile,
  updateReportFile,
  updateReportMetaInfo
} from "@/api/report.js";
// utils
import { downFile } from "@/utils/tool";

export default {
  components: {
    UploadReportFile,
    DicPortDetails,
    DicPortReout,
    UpLoadImage,
    myUploadReportFile,
    Editorbar,
    SelectTreeRadio,
    MyImageUpload,
    UploadFile,
    ButtonTable,
    FileUploadPopup
  },
  name: "ReportDataDetails",
  data() {
    var regex = (rule, value, callback) => {
      var regex = /^\d{4}-\d{2}-\d{2}$/;
      if (regex.test(value)) {
        callback();
      } else {
        callback(new Error("日期格式不对"));
      }
    };

    return {
      isClear: false,
      isShow: false,
      reportId: "", //数据唯一id
      typeTwo: false, //单份报告(fasle) 报告合集(true)
      docList: [],
      isInit: false,
      isLinkShow: false,
      isRLinkShow: false,
      editId: "",
      popupShow: false,
      queryInfo: {
        coverImageList: [], // 封面图片
        crawlId: "", // 爬虫编号
        crawlName: "", // 爬虫名称
        crawlTime: "", // 爬取时间
        crawlWebsite: "", // 爬取网站
        fetchCode: "", // 提取码
        newId: "", //  主键
        pdfImage: "", // 研报图片
        pdfImageList: [], // 研报图片list
        reportBrief: "", // 一句话介绍
        reportCollection: "", // 合集链接
        reportId: "", // 报告id
        reportIntro: "", // 研报简介
        reportKey: "", // 研报链接
        reportLabelList: [], // 赋能行业标签组
        reportName: "", // 报告名称
        reportPages: "", // 研报页数
        reportTime: "", // 发布时间
        reportType: "", // 报告类别
        type: "" // 研报类型
      },
      rules: {
        reportName: [
          { required: true, message: "请输入报告名称", trigger: "blur" }
        ],
        fileName: [
          {
            required: true,
            message: "请上传报告附件",
            trigger: "change"
          }
        ],
        reportTime: [
          {
            required: true,
            message: "请按照格式填写日期",
            trigger: "blur",
            validator: regex
          }
        ]
        // releaseTime: [
        //   {
        //     required: true,
        //     message: "请按照格式填写日期",
        //     trigger: "blur",
        //     validator: regex,
        //   },
        // ],
        // reportType: [
        //   {
        //     required: true,
        //     message: "请至少选择一个报告类型",
        //     trigger: "change",
        //   },
        // ],
      },
      reportFileList: [],
      newFilesChooseList: []
    };
  },
  watch: {
    // 监听报告类型是否是报告合集,来控制报告合集的展示
    "queryInfo.type"(newVal) {
      this.typeTwo = newVal == "报告合集" ? true : false;
    },
    queryInfo: {
      handler(newVal, oldVal) {
        this.$emit("updateInfo", newVal);
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    if (this.reportDataType) {
      this.reportId = this.$route.query.reportId;
      // this.getReportDataDetails();
      // this.getOnePortData();
    }

    this.getReportFileAPI();
  },
  computed: {
    // 0 新增 1 编辑
    reportDataType() {
      return this.$route.query.ReportDataType;
    }
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      getReportMetaInfo({ reportId: this.$route.query.reportId }).then(res => {
        if (res.code == 200) {
          this.isInit = true;

          for (let key in res.data) {
            if (
              ["coverImageList", "pdfImageList", "reportLabelList"].includes(
                key
              )
            ) {
              if (Array.isArray(res.data[key]) && res.data[key].length) {
                this.$set(this.queryInfo, key, res.data[key]);
              }
            } else {
              this.$set(this.queryInfo, key, res.data[key]);
            }
          }
        }
      });
    },
    onChangeUpLoadImgList(fieldName, val) {
      this.queryInfo[fieldName] = val.map(item => item.url);
    },
    reportsFilesChange(e) {
      this.newFilesChooseList = e;
    },
    getReportFileAPI() {
      getReportFile({ reportId: this.$route.query.reportId }).then(res => {
        if (res.code == 200 && Array.isArray(res.data)) {
          this.reportFileList = res.data;
        }
      });
    },
    downloadFactoryDoc(row) {
      downFile(
        { urlStr: this.getSeverFileUrl(row.reportFileKey) }, // 后台需要的参数
        "/public/downloadUrlFile", // 路径
        row.reportType, // 下载的文件类型
        row.reportFileName //下载文件名称
      );
    },
    handleDelete(row) {
      this.$confirm("确认删除此条附件吗 ?", "提示")
        .then(async () => {
          this.deleteReportsFileAPI([row.id]);
        })
        .catch(() => {});
    },
    handleDeletes() {
      if (!this.newFilesChooseList.length) {
        this.$message.warning("请选择需要批量删除的数据！");
        return;
      }

      this.$confirm("确认删除所选附件吗 ?", "提示").then(async () => {
        this.deleteReportsFileAPI(
          this.newFilesChooseList.map(item => {
            return item.id;
          })
        );
      });
    },
    deleteReportsFileAPI(params) {
      deleteReportFile(params).then(res => {
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.getReportFileAPI();
        }
      });
    },
    handleUploadSuccess(e) {
      const index = this.reportFileList.findIndex(item => {
        return item.id === this.editId;
      });

      this.popupShow = false;
      if (index === -1) {
        this.$message.error("修改失败");
      } else {
        this.reportFileList[index].reportType = e.type;
        this.reportFileList[index].reportFileName = e.name;
        this.reportFileList[index].reportFileKey = e.url;
        this.$refs.fileUploadPopup?.clear();
        this.updateReportsFileAPI(this.reportFileList[index]);
      }
    },
    handleEdit(row) {
      this.editId = row.id;
      this.popupShow = true;
    },
    submit() {
      this.$modal.loading("正在保存数据，请稍候...");

      updateReportMetaInfo(this.queryInfo)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
    uploadFactoryDoc(e) {
      this.insertReportsFileAPI({
        reportFileIntro: "",
        reportFileKey: e.url,
        reportFileName: e.name,
        reportId: this.$route.query.reportId,
        reportType: e.type
      });
    },
    insertReportsFileAPI(params) {
      insertReportFile(params).then(res => {
        if (res.code === 200) {
          this.$message.success("新增成功");
          this.getReportFileAPI();
        }
      });
    },
    updateReportsFileAPI(params) {
      updateReportFile(params).then(res => {
        if (res.code === 200) {
          this.$message.success("编辑成功");
          this.getReportFileAPI();
        }
      });
    },
    handleView(row) {
      window.open(this.getSeverFileUrl(row.reportFileKey));
    },
    // 报告基本信息详情
    async getReportDataDetails() {
      const res = await getReportDataDetails({
        reportId: this.reportId
      });
      if (res.code == 200) {
        this.queryInfo = res.data;
      }
    },
    //上传组件图片地址（封面图）
    clickOldTu(val) {
      this.queryInfo.pdfImage = val;
    },
    clickTu(val) {
      this.queryInfo.pdfOldImage = val;
    },
    //上传组件图片地址（报告封面）
    clickOldCover(val) {
      this.queryInfo.coverImage = val;
    },
    clickCover(val) {
      this.queryInfo.coverOldImage = val;
    },
    //(报告附件/文件名)文件上传成功返回的名字
    successUpload(val) {
      this.queryInfo.fileName = val;
    },
    //(报告附件/文件名)文件上传返回的参数
    fileKey(val) {
      this.queryInfo.reportKey = val;
    },
    //(报告合集-附件名称)文件上传成功返回的名字
    successUploadCollect(val, index) {
      this.queryInfo.reportCollectionResults[index].fileNameCollect = val;
    },
    //(报告附件/文件名)文件上传返回的参数
    fileKeyCollect(val, index) {
      this.queryInfo.reportKey = val;
    },
    // 添加标签内容等四个字段
    addReport(item) {
      this.queryInfo.reportCollectionResults.push({
        fileNameCollect: "", //附件名称
        releaseTime: "" //发布时间
      });
    },
    delReport(index) {
      this.queryInfo.reportCollectionResults.splice(index, 1);
    },
    // 根据报告类型来展不展示报告合集
    changeType(val) {
      this.typeTwo = val == "报告合集" ? true : false;
    },
    //取消
    cancelClick() {
      this.$router.go(-1);
    },
    // -----------------
    //查询单个报告数据
    async getOnePortData() {
      const res = await getSingleReort({ reportId: this.reportId });
      if (res.code == 200) {
        Object.assign(this.queryInfo, res.data);
        //行业类别转数组
        this.queryInfo.reportTags = this.formatString(
          this.queryInfo.reportTags
        );
        //领域类别转数组
        this.queryInfo.fieldId = this.formatString(this.queryInfo.fieldId);
      }
    },
    formatString(val) {
      if (!val) {
        return [];
      } else if (!val.length) {
        return val;
      } else {
        return val.split(",");
      }
    },
    updateCode(val, tag) {
      switch (tag) {
        case "行业":
          this.queryInfo.reportTagsChild = val;
          break;

        case "领域":
          this.queryInfo.fieldIdChild = val;
          break;

        default:
          break;
      }
    }
    //保存数据
    // saveItem() {
    //   if (this.ReportDataType) {
    //     this.$refs.ruleForm.validate(async (valid) => {
    //       if (valid) {
    //         //行业
    //         if (this.queryInfo.reportTagsChild) {
    //           this.queryInfo.reportTags = this.queryInfo.reportTags.concat(
    //             this.queryInfo.reportTagsChild
    //           );
    //         }
    //         //领域
    //         if (this.queryInfo.fieldIdChild) {
    //           this.queryInfo.fieldId = this.queryInfo.fieldId.concat(
    //             this.queryInfo.fieldIdChild
    //           );
    //         }
    //         const res = await updatePortData(this.queryInfo);
    //         if (res.code == 200) {
    //           this.$message.success("修改成功");
    //           this.$router.go(-1);
    //           // if (this.reportManager) {
    //           //   this.$router.push({
    //           //     name: 'ReportingNumber',
    //           //     params: {
    //           //       reportManager: this.reportManager,
    //           //     },
    //           //   });
    //           // }
    //         } else {
    //           this.$message.error(res.msg);
    //         }
    //       } else {
    //         this.$message.error("请完善基本信息!");
    //       }
    //     });
    //   } else {
    //     this.$refs.ruleForm.validate(async (valid) => {
    //       if (valid) {
    //         //行业
    //         if (this.queryInfo.reportTagsChild) {
    //           this.queryInfo.reportTags = this.queryInfo.reportTags.concat(
    //             this.queryInfo.reportTagsChild
    //           );
    //         }
    //         //领域
    //         if (this.queryInfo.fieldIdChild) {
    //           this.queryInfo.fieldId = this.queryInfo.fieldId.concat(
    //             this.queryInfo.fieldIdChild
    //           );
    //         }
    //         const res = await addNewPortData(this.queryInfo);
    //         if (res.code == 200) {
    //           this.$message.success("新增成功");
    //           this.$router.go(-1);
    //         } else {
    //           this.$message.error(res.msg);
    //         }
    //       } else {
    //         this.$message.error("请完善基本信息!");
    //       }
    //     });
    //   }
    // },
  }
  // mounted() {
  //   document.getElementsByClassName("el-tabs__content")[0].style.height =
  //     document.body.clientHeight - 242 + "px";
  // },
};
</script>

<style lang="less" scoped>
.one {
  overflow: auto;
  background: white;
}

/deep/.el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}

/deep/.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}

/deep/ .el-form-item__label {
  box-sizing: border-box;
  padding-right: 10px !important;
}
/deep/ .el-upload--picture-card {
  width: 76px !important;
  height: 76px !important;
  line-height: 76px;
}

.operate-group {
  display: flex;
  align-content: center;
}

.attr-table-box {
  margin-left: 100px;
}

.delete-box {
  margin-left: 15px;
}

.business-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .business-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }

    .table-box {
      margin-top: 10px;
      padding-left: 190px;
      padding-bottom: 10px;

      .table-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;

        &::before {
          content: "";
          display: block;
          margin-right: 4px;
          width: 7px;
          height: 7px;
          background-color: #1e9fff;
          border-radius: 50%;
        }
      }
    }
  }

  .tag {
    margin-left: 8px;
  }

  .input-radio-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
  }

  .business-honor-tags {
    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}

.attr-info {
  margin-left: 90px;
  margin-bottom: 40px;
}

.report_data_details {
  font-family: PingFang SC;
  width: 100%;
  overflow: auto;
  .report_data_details_from {
    width: 100%;
    overflow: auto;
    background-color: #fff;
    box-sizing: border-box;
    padding: 16px 20px;
  }

  .info_user {
    display: flex;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 16px 20px;
    background-color: #fff;
    flex-direction: column;
    overflow: hidden;
    align-content: center;

    .ess_people_list {
      width: 100%;
      margin: 4px 0;
      color: #7c7f8e;
      font-size: 12px;
    }
  }

  .bottom {
    border-top: 1px solid #dbdbdb;
    background: #fff;
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    .el-button {
      margin: 0 20px;
    }
  }
  .collection {
    width: 70%;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    text-align: left;
    color: #1e9fff;
  }
}
.fileName {
  /deep/.el-form-item__content {
    position: relative;
    display: flex;
    :nth-child(2) {
      position: relative;
      left: -94px;
    }
  }
  /deep/.upload-demo {
    margin-left: 10px;
  }
}
.collection {
  /deep/.el-form-item__content {
    position: relative;
    display: flex;
  }
  /deep/.upload-demo {
    margin-left: 10px;
  }
  /deep/.el-form-item {
    width: 100%;
  }
}
</style>
